export const THEME_STORAGE_KEY = 'game-color-theme'
export const DEFAULT_COLOR_SCHEME = 'dark'

export const THEME_INIT_SCRIPT = `(function(){try{var k='${THEME_STORAGE_KEY}';var s=localStorage.getItem(k);var t=s==='light'?'light':'dark';document.documentElement.classList.add(t)}catch(e){document.documentElement.classList.add('dark')}})();`
